import React, { useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router';
import { replace } from 'connected-react-router';
import Loader from 'Common/components/Loader';
import RetryLoading from 'Common/components/RetryLoading';
import DriverLicenseControlOverview from 'Measure/components/vehicle/driver-license/overview/DriverLicenseControlOverview';
import useAxiosRequest from 'Common/hooks/useAxiosRequest';
import getDriverLicenseControl from 'Measure/api/driver-license/getDriverLicenseControl';

const DriverLicenseExaminerOverview = () => {
    const dispatch = useDispatch();
    const { id: driverLicenseControlId } = useParams();

    const driverLicenseControlRequest = useCallback(
        cancelToken =>
            getDriverLicenseControl(
                driverLicenseControlId,
                [
                    'examiners',
                    'employee',
                    'employee.user',
                    'driverLicense',
                    'driverLicense.checks',
                    'driverLicense.checks.sentEmails',
                    'driverLicense.nextCheck',
                    'driverLicense.nextCheck.directProcedure',
                    'driverLicense.nextCheck.distanceProcedure',
                    'driverLicense.nextCheck.previousDistanceProcedure',
                    'driverLicense.nextCheck.previousDistanceProcedure.examiner',
                ],
                cancelToken,
            ),
        [driverLicenseControlId],
    );

    const {
        data: driverLicenseControl,
        loadData: loadDriverLicenseControl,
        isLoading,
        hasError,
        error,
    } = useAxiosRequest(driverLicenseControlRequest, null);

    useEffect(() => {
        const responseStatus = error?.response?.status;

        if (responseStatus === 404 || responseStatus === 401) {
            dispatch(replace('/404'));
        }
    }, [dispatch, error]);

    if (isLoading) {
        return <Loader />;
    }

    if (hasError) {
        return <RetryLoading onRetry={loadDriverLicenseControl} />;
    }

    return (
        <DriverLicenseControlOverview
            driverLicenseControl={driverLicenseControl}
        />
    );
};

export default DriverLicenseExaminerOverview;
